import styled from 'styled-components'

export const PageLayout = styled.div`
    display: flex;
    gap: 24px;
    align-items: flex-start;
    width: 100%;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`
